
import { Vue } from "vue-class-component"; //基本需要\
import {
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  unique_json,
} from "@/utils";
import {
  readGetTestCaseList,
  readGetTestCase,
  readGetTaskList,
} from "@/store/performance/getters"; //引入仓库接口
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
} from "@/store/project/getters";
import {
  dispatchGetMyProjects,
  dispatchGetProjectDetail,
  dispatchGetProjects,
} from "@/store/project/actions";
import {
  dispatchgetTestCaseList,
  dispatchgetTestCase,
  dispatchCaseControl,
  dispatchCaseDetail,
  dispatchGetTaskList,
} from "@/store/performance/actions";

import { dispatchUpdateMyLastProject } from "@/store/main/actions";
import { store } from "@/store"; //引入仓库
import "@/assets/iconfont/iconfont.css"; //引入仓库
export default class AutoTest extends Vue {
  public id = "";
  public dom = "";
  public get elBtnList() {
    let list: any = [];
    let icon = [
      "iconfont icon-denglu",
      "iconfont icon-fangjian",
      "iconfont icon--shuju-pipei",
      "iconfont icon-qiehuanjiaose",
      "iconfont icon-qiehuan",
      "iconfont icon-ditu",
      "iconfont icon-tubiaozhizuomoban",
      "iconfont icon-firearms",
      "iconfont icon-qiehuan1",
      "iconfont icon-jieshu",
    ];
    list = readGetTestCaseList(store);
    list?.forEach((item, index) => {
      // console.log(item.params)
      // item.params = item.params ? JSON.parse(item.params) : {};
      // console.log(item.params)
      list[index].icon = icon[index];
    });

    return list;
  }
  public status = "";
  public task = {
    task_id: "",
    task_name: "",
  };
  public taskShow = false;
  public taskText = "";
  public status1 = [];
  public typeStatus(item) {
    if (item === 0) {
      return "未开始";
    } else {
      return "执行中";
    }
  }
  public get testCase() {
    readGetTestCase(store).content = JSON.parse(readGetTestCase(store).content);
    this.content = readGetTestCase(store).content;
    // if(readGetTestCase(store).task!=null){
    //     this.task=readGetTestCase(store).task
    // }

    this.status = readGetTestCase(this.$store).status;
    return readGetTestCase(store);
  }
  public removeBtnALL(item, index) {
    item.splice(index, 1);
  }
  public removeBtn(index, v) {
    this.content.case_list[v].action_list.splice(index, 1);
    if (this.content.case_list[v].action_list.length === 0) {
      this.content.case_list.splice(v, 1);
    }
  }
  getProjects(search?: string) {
    const projects: any[] = readMyProjects(store);
    for (let project of projects) {
      project.label = project.project.project_name;
      project.value = project.project.id;
    }
    return unique_json(projects, "value").filter(
      (data) =>
        !search || data.label?.toLowerCase().includes(search.toLowerCase())
    );
  }
  get getMyLastProjectName() {
    for (let project of readAdminProjects(store)) {
      if (project.id === this.localProject) {
        return project.project_name;
      }
    }
    return this.getProjects().filter(
      (item) => item.id === this.localProject
    )[0];
  }
  // public getStatus(item){

  // }
  public content = {
    case_list: [
      {
        action_list: [
          { action: "", param1: "", param2: "", param3: "", status: 0 },
        ],
        case_name: "",
      },
    ],
  };
  public async start(item) {
    let upload_data = {
      project: this.localProject,
      control_type: item,
    };
    await dispatchCaseControl(store, { data: upload_data });
    await dispatchgetTestCase(store, { project: this.localProject });
    await this.testCase;
    this.timeout(true);
  }
  public async end(item) {
    let upload_data = {
      project: this.localProject,
      control_type: item,
    };
    await dispatchCaseControl(store, { data: upload_data });
    await dispatchgetTestCase(store, { project: this.localProject });
    await this.testCase;
  }
  public textShow = false;
  public textChange(item, index) {
    this.textShow = false;
  }
  public detail() {
    dispatchCaseDetail(store, {
      id: this.testCase.id,
      project: this.localProject,
      content: JSON.stringify(this.content),
    });
  }
  public typeColor(item) {
    if (item == "未设置") {
      return "gray";
    }
    if (item == "执行失败") {
      return "red";
    } else if (item === "执行成功") {
      return "#00b050";
    } else if (item === "执行完成") {
      return "#00b050";
    } else if (item === "初始化") {
      return "#303133";
    } else if (item === "执行中") {
      return "#ffa500";
    }
  }
  public caseStatusColor(item) {
    if (item === "未开始") {
      return "#303133";
    } else if (item === "执行中") {
      return "#00b050";
    }
  }
  public getStatus(item) {
    if (item == 0) {
      return "未设置";
    }
    if (item == 1) {
      return "初始化";
    }
    if (item == 2) {
      return "执行中";
    }
    if (item == 3) {
      return "执行完成";
    }
    if (item == 4) {
      return "执行成功";
    }
    if (item == 5) {
      return "执行失败";
    }
  }
  public add() {
    this.content.case_list.push({
      action_list: [],
      case_name: "用例名",
    });
  }
  public case_list = [
    {
      action_list: [
        { action: "", status: "", param1: "", param2: "", param3: "" },
      ],
      case_name: 0,
    },
  ];
  public form = [{ name: "", input1: "", input2: "", input3: "" }];
  drag(ev, id) {
    this.id = id;
    this.dom = ev.currentTarget.cloneNode(true);
  }
  允许放下拖拽;
  allowDrop(ev) {
    ev.preventDefault();
  }
  放下事件;
  drop(ev, item, i, k) {
    ev.preventDefault();
    // if(this.content.case_list[i].action_list.length===1){
    //   this.content.case_list[i].action_list[0].action=item
    // }
    this.content.case_list[i].action_list.push({
      action: item,
      status: 0,
      param1: "",
      param2: "",
      param3: "",
    });
  }
  // drop1(ev, item, i,k) {
  //   console.log("放下", item, i,k);
  //   console.log(ev);
  //   ev.preventDefault();
  //   if(this.content.case_list[i].action_list.length===1){
  //     this.content.case_list[i].action_list[0].action=item
  //   }

  // }
  public changeProject(value: any) {
    dispatchUpdateMyLastProject(store, { last_visit_project: value });
    saveLocalProject(String(value));
    saveLocalStorageProject(String(value));
    // 不可注释
    this.$router.push({
      path: "/test1",
    });
  }
  public localProject = Number(getLocalProject()); //得到本地的项目
  public num = 0;
  public timeout(is_run: boolean): void {
    this.num++;
    if (is_run && readGetTestCase(this.$store)?.status === 1) {
      const timer = setTimeout(() => {
        if (this.$router.currentRoute.value.name !== "AutoTest") {
          this.timeout(false);
        } else {
          this.refreshTaskRecord();
          this.timeout(is_run);
        }
      }, 10000);
    }
  }
  public async refreshTaskRecord() {
    await dispatchgetTestCase(store, { project: this.localProject });
    await this.testCase;
  }
  public async mounted() {
    dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    await dispatchGetTaskList(store, { project: this.localProject });
    await this.elBtnList;
    await dispatchGetMyProjects(store);
    await dispatchGetProjects(store, { project: this.localProject });
    dispatchgetTestCaseList(store, { project: this.localProject });
    await dispatchgetTestCase(store, { project: this.localProject });
    await this.testCase;
  }
  public get currentProjectIcon() {
    return readProjectDetail(store).icon;
  }
  public rightBox = false;
  public pad = "0px";
  public bkg = "rgb(84, 92, 100)";
  public colorText = "#fff";
  public inHover() {
    this.rightBox = true;
    this.bkg = "#fff";
    this.pad = "10px";
    this.colorText = "#909cad";
  }
  public get RecentTaskList() {
    return readGetTaskList(store);
  }
  public outHover() {
    this.rightBox = false;
    this.pad = "0px";
    this.bkg = "rgb(84, 92, 100)";
    this.colorText = "#fff";
  }
}
